import React from 'react'
import Block from '../../components/block'
import Button from '../../components/button'
import Divider from '../../components/divider'
import Heading from '../../components/heading'
import Text from '../../components/text'
import GabLogo from '../../components/logo'
import { me } from '../../initial_state'

export default class VpnPolicy extends React.PureComponent {

  render() {
    const loggedIn = me !== undefined && me !== null && me !== ''
    
    return (
      <div className={[_s.default, _s.minH50VH, _s.maxW80VW, _s.mauto, _s.pt53PX].join(' ')}>
        <Block className={[_s.mauto].join(' ')}>
          <div className={[_s.default, _s.px15, _s.py15, _s.mb10].join(' ')}>
            <div className={[_s.default, _s.aiCenter, _s.jcCenter, _s.mb15].join(' ')}>
              <GabLogo height='55px' width='90px' />
            </div>
            
            <Heading>VPN Policy</Heading>
            
            <div className={[_s.d, _s.mt15, _s.pb15, _s.w100PC].join(' ')}>
              <Text tagName='p' className={_s.mt15} size='medium'>
                We do not allow VPNs or proxy services to access our site, unless you are logged in and subscribed to Gab PRO.  If you are using a VPN or proxy service, please disconnect and try again, or log in and subscribe.
              </Text>

              <Text tagName='p' className={_s.mt15} size='medium'>
                This policy is now in place to protect our community from foreign subversives, third-world scammers, and other bad actors.
              </Text>

              <Text tagName='p' className={_s.mt15} size='medium'>
                If you are seeing this on an iOS device and are not using a 3rd party VPN, please see this article on disabling Private Relay: <a className={_s.colorNavigation} href='https://support.apple.com/en-us/102022'>https://support.apple.com/en-us/102022</a>
              </Text>
              
              <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt15, _s.jcCenter].join(' ')}>
                {!loggedIn && (
                  <Button
                    radiusSmall
                    backgroundColor='tertiary'
                    color='primary'
                    href='/auth/sign_in'
                    className={[_s.mr10].join(' ')}
                  >
                    <Text color='inherit' weight='medium'>Login</Text>
                  </Button>
                )}
                
                {loggedIn && (
                  <Button
                    radiusSmall
                    backgroundColor='brand'
                    color='white'
                    href='https://pro.gab.com'
                  >
                    <Text color='inherit' weight='medium'>Subscribe to Gab PRO</Text>
                  </Button>
                )}

                {loggedIn && (
                  <Button
                    radiusSmall
                    backgroundColor='tertiary'
                    color='primary'
                    href='/auth/sign_out'
                    className={[_s.ml10].join(' ')}
                  >
                    <Text color='inherit' weight='medium'>Logout</Text>
                  </Button>
                )}

              </div>
            </div>
          </div>
        </Block>
      </div>
    )
  }
}
